const locale = {
  dashboard: 'Dashboard',
  home_dashboard: 'Home',
  dashboard_news: 'News',
  dashboard_slides: 'Slides',
  dashboard_notifications: 'Notifications',
  dashboard_account: 'My account',
  dashboard_team: 'My team',
  dashboard_mini_site: 'Mini-site',
  dashboard_loyalty_campaign: 'Loyalty campaign',
  product_order: 'Products order',
  digital_pub: 'Digital advertising',
  training: 'Training',
  dashboard_content_library: 'Content library',
  documentation: 'Documentation',
  intranet_doc: 'Documentary area',
  hairdressers_network: 'Hairdressers network',
  hairdressers: 'Hairdressers',
  hairdressers_list: 'Hairdressers list',
  hairdresser_add: 'Add a hairdresser',
  link_hairdresser_supervisor: 'Link hairdresser / supervisor',
  services: 'Services',
  services_list: 'Services list',
  services_add: 'Add a service',
  services_link: 'Link a service',
  national_operations: 'National operations',
  national_operation: 'National operation',
  national_operations_list: 'National op. list',
  national_operations_add: 'Add a national op.',
  national_operations_participate: 'Link to a national op.',
  prices: 'Catalog and prices',
  prices_list: 'List of services & rates',
  legals_list: 'List of legal notices',
  legals_add: 'Add a legal notice',
  legals_participate: 'Associate a legal notice',
  jobs: 'Jobs',
  jobs_list: 'Jobs list',
  jobs_add: 'Add a job',
  customer_relationship: 'Customer relationship',
  contacts: 'Contacts',
  contacts_list: 'Contacts list',
  contacts_import: 'Importer contacts',
  origin_code_list: 'Origins list',
  origin_code_add: 'Add an origin',
  feedbacks: 'Feedbacks',
  feedbacks_list: 'Feedbacks list',
  feedbacks_response_model: 'Feedback response model',
  feedbacks_receiver: 'Feedback receiver',
  access: 'Access',
  collaborators: 'Collaborators list',
  collaborators_add: 'Add a collaborator',
  users_and_groups: 'Users and groups',
  users_list: 'Users list',
  users_add: 'Add a user',
  groups_list: 'Groups list',
  groups_add: 'Add a group',
  press: 'Press area',
  press_admin: 'Press administration',
  resources: 'Resources',
  mass_administration: 'Mass management',
  minisite: 'Minisites',
  minisiteList: 'Update tracking',
  minisiteMessageList: 'List of greetings',
  minisiteTagList: 'List of meta tags',
  minisiteMassiveImport: 'Bulk Administration',
  access_to: 'Access to',
  payment_x3: 'Pay in 3x',
  mass_administration_price_list: 'Services & Prices',
  mass_administration_businessHours_list: 'Business Hours',
  mass_administration_message_list: 'List of Greetings',
  mass_administration_tag_list: 'List of Tags',
  mass_administration_picture_list: 'Photos',
  terms_nav: 'Terms and Conditions',
  TOU: 'Terms of Use',
  privacy_policy: 'Privacy Policy',
  cookies_policy: 'Cookie management policy',
  faq: 'Frequently Asked Questions'
};

export default locale;
